import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({ token: null, role: null, userId: null, username: null, employeeName: null });

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('authRole');
    const userId = localStorage.getItem('authUserId');
    const username = localStorage.getItem('authUserName');
    const employeeName = localStorage.getItem('authEmployeeName');

    if (token && role && userId && username && employeeName) {
      setAuth({ token, role, userId, username, employeeName });
    }
  }, []);

  const login = (token, role, userId, username, employeeName) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('authRole', role);
    localStorage.setItem('authUserId', userId);
    localStorage.setItem('authUserName', username);
    localStorage.setItem('authEmployeeName', employeeName);
    setAuth({ token, role, userId, username, employeeName });
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authRole');
    localStorage.removeItem('authUserId');
    localStorage.removeItem('authUserName');
    localStorage.removeItem('authEmployeeName');
    setAuth({ token: null, role: null, userId: null, username: null, employeeName: null });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
